import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { courseService } from "../../../../_services";
import Charts, {
  ActiveUsersByCountry,
  CountChart,
  CourseViewHistory,
  DashboardCombineChart,
  DashboardLine,
  DashboardSchool,
} from "../../assets/chartComponent/DashboardCharts";
import UserAvatar from "../../UserAvatar/UserAvatar";
import { Loading } from "../../../Other/Loading";
import "../../dashboard.scss";
import { AuthorizedWrapper } from "../../../Other/AuthorizedWrapper";
import CourseList from "../../Teachers/CourseList";
import EnterprisePayment from "../../../Enterprise/EnterprisePayment";
import { useSelector } from "react-redux";
import TeacherAdminData from "./TeacherAdminData";
import Pdf from "react-to-pdf";
import AdminListData from "./AdminListData";
import InstructorListData from "./InstructorListData";
import UpcomingWebinar from "./UpcomingWebinar";
import DashboardCalendar from "./DashboardCalendar";
import AdminTableData from "./AdminTableData";
import StudentDashboard from "./StudentDashboard";
import map from "../../assets/images/map.jpg";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import axiosInstance from "../../../../axios";
import InstructorAttendance from "../../Teachers/MemberList/InstructorAttendance";
import VerifyAttendance from "../../Teachers/MemberList/VerifyAttendance";
import { courseActions, userActions } from "@/_actions";
import { categoryActions } from "@/_actions/category.actions";
import {
  FaBullhorn,
  FaCheckSquare,
  FaPlus,
  FaCheck,
  FaTimes,
  FaCalendarAlt,
  FaClock,
  FaChalkboardTeacher,
  FaUsers,
  FaShieldAlt,
} from "react-icons/fa";
function Dashboard(props) {
  const dispatch = useDispatch();
  const [getJustAddedCourse, setGetJustAddedCourse] = useState();
  const [fetchrecord, setFetchRecord] = useState();
  const [fetchRes, setFetchRes] = useState(false);
  const [fetchStatus, setFetchStatus] = useState(true);
  const [progressIndex, setProgressIndex] = useState(5);
  const [announcement, setAnnouncement] = useState([]);
  const [loading, setLoading] = useState(false);
  const { courses, isFetching } = useSelector(state => state?.course || []);
  //console.log("courses", courses);
  const courseList = courses?.all?.courses || [];

  const [adminChecklist, setAdminChecklist] = useState(() => {
    const saved = localStorage.getItem("admin_checklist");
    return saved ? JSON.parse(saved) : [
      { id: 1, text: "Verify pending instructor credentials", checked: false },
      { id: 2, text: "Moderate new courses in review queue", checked: false },
      { id: 3, text: "Check system transaction logs", checked: false },
      { id: 4, text: "Post a weekly announcement update", checked: false },
    ];
  });

  const [instructorChecklist, setInstructorChecklist] = useState(() => {
    const saved = localStorage.getItem("instructor_checklist");
    return saved ? JSON.parse(saved) : [
      { id: 1, text: "Record attendance for today's class", checked: false },
      { id: 2, text: "Upload resources for upcoming batch", checked: false },
      { id: 3, text: "Reply to student forum questions", checked: false },
      { id: 4, text: "Review recent quiz submissions", checked: false },
    ];
  });

  useEffect(() => {
    localStorage.setItem("admin_checklist", JSON.stringify(adminChecklist));
  }, [adminChecklist]);

  useEffect(() => {
    localStorage.setItem("instructor_checklist", JSON.stringify(instructorChecklist));
  }, [instructorChecklist]);

  const handleToggleAdminChecklist = (id) => {
    setAdminChecklist(prev => prev.map(item => item.id === id ? { ...item, checked: !item.checked } : item));
  };

  const handleToggleInstructorChecklist = (id) => {
    setInstructorChecklist(prev => prev.map(item => item.id === id ? { ...item, checked: !item.checked } : item));
  };

  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
  const [newAnnouncement, setNewAnnouncement] = useState({ title: "", description: "", targetGroup: "all" });
  const [postingAnnouncement, setPostingAnnouncement] = useState(false);
  const [announcementError, setAnnouncementError] = useState("");
  const [announcementSuccess, setAnnouncementSuccess] = useState("");

  const handlePostAnnouncement = async (e) => {
    e.preventDefault();
    if (!newAnnouncement.title.trim() || !newAnnouncement.description.trim()) {
      setAnnouncementError("Please fill out all fields.");
      return;
    }
    setPostingAnnouncement(true);
    setAnnouncementError("");
    setAnnouncementSuccess("");
    try {
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 10);
      const payload = {
        name: newAnnouncement.title,
        title: newAnnouncement.title,
        description: newAnnouncement.description,
        targetGroup: newAnnouncement.targetGroup || "all",
        data: [
          {
            activationDate: new Date().toISOString(),
            expirationDate: expirationDate.toISOString(),
          }
        ]
      };
      const res = await axiosInstance.post("/announcement", payload);
      if (res.data && !res.data.error) {
        setAnnouncementSuccess("Announcement posted successfully!");
        setNewAnnouncement({ title: "", description: "", targetGroup: "all" });
        fetchAnnouncements();
        setTimeout(() => {
          setShowAnnouncementModal(false);
          setAnnouncementSuccess("");
        }, 1500);
      } else {
        setAnnouncementError(res.data?.message || "Failed to post announcement.");
      }
    } catch (err) {
      console.error("Error posting announcement:", err);
      setAnnouncementError(err.response?.data?.message || "An error occurred while posting.");
    } finally {
      setPostingAnnouncement(false);
    }
  };

  const ref = useRef();
  const navigate = useNavigate();

  const quickStats = [
    { name: "New Course", action: "/dashboard/course/list" },
    { name: "New Students", action: "/dashboard/student/Lists" },
    { name: "New Instructor", action: "/dashboard/instructor/list" },
    { name: "Total Payment Transactions", action: "" },
    { name: "Total Webinar", action: "" },
    { name: "B2B Inquiry", action: "" },
  ];

  useEffect(() => {
    // dispatch(courseActions.handleResetCourseList());
    // dispatch(courseActions.fetchCourses());
    // dispatch(userActions.getGeoLocation());
    // dispatch(courseActions.myCourses())
    // dispatch(categoryActions.getCategories());
    dispatch(courseActions.purchasedCourses());
  }, []);


  const fetchAnnouncements = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/announcement/");
      setAnnouncement(res.data.data);
      //console.log(res.data.data, "announcement");
    } catch (error) {
      console.error("Error fetching announcements:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);


  const accouncements = [
    {
      name: "Pellentesque mi dui, egestas sit amet risus ut",
      lastUpdate: "05-12-22",
      time: "06:02:04",
    },
    {
      name: "Curabitur et nunc libero. Aliquam euismod maximus magna",
      time: "06:02:04",
      lastUpdate: "28-11-22",
    },
    {
      name: "Morbi quis accumsan diam integer convallis eros",
      time: "06:02:04",
      lastUpdate: "03-12-22",
    },
    {
      name: "Maecenas tristique enim eget risus lobortis ",
      time: "06:02:04",
      lastUpdate: "04-12-22",
    },
  ];

  const statistics = () => {
    if (props.user.role === 1) {
      courseService
        .userStatics()
        .then((res) => {
          setFetchRecord(res.data.data);
          setFetchRes(false);
        })
        .catch((res) => {
          console.log("error", res);
        });
    }
  };

  useEffect(() => {
    setFetchRes(true);
    statistics();
    sessionStorage.clear();
  }, []);
  const options = {
    orientation: "landscape",
    unit: "in",
    format: [8, 9],
  };


  useEffect(() => {
    const fetchPurchasedCourses = async () => {
      try {
        const res = await axiosInstance.get("/course/purchased");
        setGetJustAddedCourse(res?.data?.data?.data);
      } catch (error) {
        console.error("Error fetching purchased courses:", error);
      } finally {
        setFetchStatus(false);
      }
    };

    fetchPurchasedCourses();
  }, []);



  const coursePercentageCalutation = (value) => {
    const totalDuration = value.totalSection;
    const totalDurationCompleted = value.finishedSection;
    const percenatge = (totalDurationCompleted / totalDuration) * 100;
    return totalDuration === 0 ? 0 : percenatge;
  };
  return props.user ? (
    <div className="container-wrapper">
      <AuthorizedWrapper authorizedRoles={["Admin"]}>
        <div ref={ref} style={{ fontFamily: "'Outfit', sans-serif", padding: "10px" }}>
          {/* Admin Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "#f8fafc",
              padding: "16px 24px",
              borderRadius: "16px",
              border: "1px solid #e2e8f0",
              marginBottom: "24px",
            }}
          >
            <p style={{ margin: 0, fontSize: "20px", fontWeight: "800", color: "#0f172a" }}>
              Admin Console
            </p>
            <span style={{ fontSize: "12px", background: "#eff6ff", color: "#2563eb", fontWeight: "700", padding: "6px 12px", borderRadius: "20px", border: "1px solid #dbeafe" }}>
              Role: System Administrator
            </span>
          </div>

          {/* Welcome Hero Banner (Admin) */}
          <div
            style={{
              background: "linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #334155 100%)",
              borderRadius: "24px",
              padding: "32px",
              color: "white",
              marginBottom: "30px",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 12px 30px rgba(15, 23, 42, 0.15)",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-20%",
                right: "-10%",
                width: "350px",
                height: "350px",
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0) 70%)",
                filter: "blur(25px)",
                zIndex: 1,
              }}
            />
            <div style={{ position: "relative", zIndex: 2 }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                <div style={{ background: "rgba(255,255,255,0.1)", padding: "6px", borderRadius: "8px" }}>
                  <FaShieldAlt style={{ color: "#60a5fa", fontSize: "16px" }} />
                </div>
                <span style={{ fontSize: "12px", fontWeight: "800", letterSpacing: "0.05em", color: "#94a3b8", textTransform: "uppercase" }}>System Secure</span>
              </div>
              <h1 style={{ fontSize: "30px", fontWeight: "800", margin: "0 0 10px 0", letterSpacing: "-0.02em" }}>
                Welcome back, {props.user.firstName || "Administrator"}! 🛡️
              </h1>
              <p style={{ fontSize: "15px", color: "#cbd5e1", margin: "0 0 24px 0", maxWidth: "650px", fontWeight: "500", lineHeight: "1.6" }}>
                System operational. Manage courses, verify teachers, and moderate registration requests. Add announcements directly to students and instructors below.
              </p>

              {/* Admin Quick Action Shortcuts */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
                <button
                  onClick={() => setShowAnnouncementModal(true)}
                  style={{
                    background: "#3b82f6",
                    color: "white",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "12px",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "#2563eb"; e.currentTarget.style.transform = "translateY(-1px)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "#3b82f6"; e.currentTarget.style.transform = "translateY(0)"; }}
                >
                  <FaBullhorn /> Create Announcement
                </button>
                <button
                  onClick={() => navigate('/dashboard/instructor/list')}
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    color: "white",
                    border: "1px solid rgba(255,255,255,0.15)",
                    padding: "10px 20px",
                    borderRadius: "12px",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)"; }}
                >
                  Verify Instructors
                </button>
                <button
                  onClick={() => navigate('/dashboard/course/list', { state: { type: "inReview" } })}
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    color: "white",
                    border: "1px solid rgba(255,255,255,0.15)",
                    padding: "10px 20px",
                    borderRadius: "12px",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)"; }}
                >
                  Course Moderation
                </button>
                <button
                  onClick={() => navigate('/dashboard/Announcement')}
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    color: "white",
                    border: "1px solid rgba(255,255,255,0.15)",
                    padding: "10px 20px",
                    borderRadius: "12px",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)"; }}
                >
                  Manage Announcements
                </button>
              </div>
            </div>
          </div>

          <div className="dashboard-main" style={{ gap: "24px" }}>
            <div className="flex-80" style={{ flexBasis: "calc(76% - 18px)", marginBottom: "0" }}>
              <AdminListData />

              <div className="dashboard-main" style={{ gap: "24px" }}>
                <div className="flex-chart-60" style={{ flex: "1 1 58%", minWidth: "300px" }}>
                  <div style={{ marginBottom: "24px" }}>
                    <div
                      style={{
                        background: "white",
                        borderRadius: "24px",
                        padding: "24px",
                        border: "1px solid rgba(226, 232, 240, 0.8)",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                      }}
                    >
                      <p style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Enrollment Analytics</p>
                      <DashboardCombineChart />
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        background: "white",
                        borderRadius: "24px",
                        padding: "24px",
                        border: "1px solid rgba(226, 232, 240, 0.8)",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                      }}
                    >
                      <p style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Course View Metrics</p>
                      <CourseViewHistory />
                    </div>
                  </div>
                </div>

                <div className="flex-chart-40" style={{ flex: "1 1 38%", minWidth: "260px", display: "flex", flexDirection: "column", gap: "24px" }}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: "24px",
                      padding: "24px",
                      border: "1px solid rgba(226, 232, 240, 0.8)",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                    }}
                  >
                    <p style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Registration Activity</p>
                    <div style={{ height: "350px" }}>
                      <DashboardLine chartTitle="Registration" />
                    </div>
                  </div>                   
                  <div
                    style={{
                      background: "white",
                      borderRadius: "24px",
                      padding: "24px",
                      border: "1px solid rgba(226, 232, 240, 0.8)",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                    }}
                  >
                    <p style={{ margin: "0 0 12px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>
                      Moderation Queue
                    </p>
                    <Charts />
                  </div>

                  <div
                    style={{
                      background: "white",
                      borderRadius: "24px",
                      padding: "24px",
                      border: "1px solid rgba(226, 232, 240, 0.8)",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                    }}
                  >
                    <p style={{ margin: "0 0 12px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>
                      Course Status Overview
                    </p>
                    <CountChart />
                  </div>
                </div>
              </div>

              <div className="dashboard-main" style={{ gap: "24px", marginTop: "24px" }}>
                <div style={{ flex: "1 1 35%", minWidth: "260px" }}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: "24px",
                      padding: "24px",
                      border: "1px solid rgba(226, 232, 240, 0.8)",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                    }}
                  >
                    <p style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Demographics</p>
                    <ActiveUsersByCountry />
                  </div>
                </div>
                <div style={{ flex: "1 1 60%", minWidth: "300px" }}>
                  <AdminTableData />
                </div>
              </div>
            </div>

            <div className="flex-20" style={{ flexBasis: "calc(24% - 6px)", display: "flex", flexDirection: "column", gap: "24px" }}>
              {/* Daily Checklist Card */}
              <div
                style={{
                  background: "white",
                  borderRadius: "24px",
                  padding: "24px",
                  border: "1px solid rgba(226, 232, 240, 0.8)",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
                  <FaCheckSquare style={{ color: "#3b82f6" }} />
                  <p style={{ margin: 0, fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Daily Tasks</p>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  {adminChecklist.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => handleToggleAdminChecklist(item.id)}
                      style={{
                        display: "flex",
                        alignItems: "start",
                        gap: "10px",
                        cursor: "pointer",
                        padding: "8px 10px",
                        borderRadius: "10px",
                        background: item.checked ? "#f8fafc" : "transparent",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = "#f1f5f9"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = item.checked ? "#f8fafc" : "transparent"; }}
                    >
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          borderRadius: "4px",
                          border: "2px solid #cbd5e1",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "2px",
                          borderColor: item.checked ? "#3b82f6" : "#cbd5e1",
                          background: item.checked ? "#3b82f6" : "transparent",
                          transition: "all 0.2s ease",
                          flexShrink: 0,
                        }}
                      >
                        {item.checked && <FaCheck style={{ color: "white", fontSize: "10px" }} />}
                      </div>
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: item.checked ? "#94a3b8" : "#475569",
                          textDecoration: item.checked ? "line-through" : "none",
                        }}
                      >
                        {item.text}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Enquiries Card */}
              <div
                style={{
                  background: "white",
                  borderRadius: "24px",
                  padding: "24px",
                  border: "1px solid rgba(226, 232, 240, 0.8)",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                }}
              >
                <p style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>
                  Recent Enquiries
                </p>
                <TeacherAdminData enquiry={true} />
              </div>
            </div>
          </div>
        </div>
      </AuthorizedWrapper>

      <AuthorizedWrapper authorizedRoles={["Instructor"]}>
        <div ref={ref} style={{ fontFamily: "'Outfit', sans-serif", padding: "10px" }}>
          {/* Instructor Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "#f8fafc",
              padding: "16px 24px",
              borderRadius: "16px",
              border: "1px solid #e2e8f0",
              marginBottom: "24px",
            }}
          >
            <p style={{ margin: 0, fontSize: "20px", fontWeight: "800", color: "#0f172a" }}>
              Instructor Panel
            </p>
            <span style={{ fontSize: "12px", background: "#ecfdf5", color: "#059669", fontWeight: "700", padding: "6px 12px", borderRadius: "20px", border: "1px solid #a7f3d0" }}>
              Role: Course Instructor
            </span>
          </div>

          {/* Welcome Hero Banner (Instructor) */}
          <div
            style={{
              background: "linear-gradient(135deg, #064e3b 0%, #022c22 60%, #022c22 100%)",
              borderRadius: "24px",
              padding: "32px",
              color: "white",
              marginBottom: "30px",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 12px 30px rgba(6, 78, 59, 0.15)",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-20%",
                right: "-10%",
                width: "350px",
                height: "350px",
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(16, 185, 129, 0.15) 0%, rgba(16, 185, 129, 0) 70%)",
                filter: "blur(25px)",
                zIndex: 1,
              }}
            />
            <div style={{ position: "relative", zIndex: 2 }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                <div style={{ background: "rgba(255,255,255,0.1)", padding: "6px", borderRadius: "8px" }}>
                  <FaChalkboardTeacher style={{ color: "#34d399", fontSize: "16px" }} />
                </div>
                <span style={{ fontSize: "12px", fontWeight: "800", letterSpacing: "0.05em", color: "#a7f3d0", textTransform: "uppercase" }}>Teaching Console</span>
              </div>
              <h1 style={{ fontSize: "30px", fontWeight: "800", margin: "0 0 10px 0", letterSpacing: "-0.02em" }}>
                Welcome back, {props.user.firstName || "Instructor"}! 🎓
              </h1>
              <p style={{ fontSize: "15px", color: "#cbd5e1", margin: "0 0 24px 0", maxWidth: "650px", fontWeight: "500", lineHeight: "1.6" }}>
                Track student progress, schedule new classes, manage webinars, and record student attendance. Use the checklist on the right to track daily goals.
              </p>

              {/* Instructor Actions */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
                <button
                  onClick={() => navigate('/dashboard/instructor/classes')}
                  style={{
                    background: "#10b981",
                    color: "white",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "12px",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(16, 185, 129, 0.2)",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "#059669"; e.currentTarget.style.transform = "translateY(-1px)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "#10b981"; e.currentTarget.style.transform = "translateY(0)"; }}
                >
                  Schedule Live Class
                </button>
                <button
                  onClick={() => navigate('/dashboard/course/list')}
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    color: "white",
                    border: "1px solid rgba(255,255,255,0.15)",
                    padding: "10px 20px",
                    borderRadius: "12px",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)"; }}
                >
                  My Course List
                </button>
              </div>
            </div>
          </div>

          <div className="dashboard-main" style={{ gap: "24px" }}>
            <div className="flex-80" style={{ flexBasis: "calc(76% - 18px)", marginBottom: "0" }}>
              <InstructorListData />

              <div className="dashboard-main" style={{ gap: "24px", marginTop: "24px" }}>
                <div style={{ flex: "1 1 58%", minWidth: "300px" }}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: "24px",
                      padding: "24px",
                      border: "1px solid rgba(226, 232, 240, 0.8)",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                    }}
                  >
                    <p style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Course Enrollment Activity</p>
                    <DashboardCombineChart instructor={true} />
                  </div>
                </div>

                <div style={{ flex: "1 1 38%", minWidth: "260px", display: "flex", flexDirection: "column", gap: "24px" }}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: "24px",
                      padding: "24px",
                      border: "1px solid rgba(226, 232, 240, 0.8)",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                    }}
                  >
                    <p style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Student Growth Trends</p>
                    <div style={{ height: "180px" }}>
                      <DashboardLine chartTitle="Enrollment" instructor={true} />
                    </div>
                  </div>

                  <div
                    style={{
                      background: "white",
                      borderRadius: "24px",
                      padding: "24px",
                      border: "1px solid rgba(226, 232, 240, 0.8)",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                    }}
                  >
                    <p style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Webinars Scheduled</p>
                    <DashboardSchool chartTitle="Webinar By Month" instructor={true} />
                  </div>
                </div>
              </div>

              <div className="dashboard-main" style={{ gap: "24px", marginTop: "24px" }}>
                <div style={{ flex: "1 1 35%", minWidth: "260px" }}>
                  <UpcomingWebinar />
                </div>
                <div style={{ flex: "1 1 60%", minWidth: "300px" }}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: "24px",
                      padding: "24px",
                      border: "1px solid rgba(226, 232, 240, 0.8)",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                    }}
                  >
                    <p style={{ margin: "0 0 20px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Announcements List</p>
                     <div style={{ overflowX: "auto" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead>
                            <tr style={{ borderBottom: "2px solid #f1f5f9" }}>
                              <th style={{ textAlign: "left", padding: "12px 16px", fontSize: "11px", fontWeight: "800", color: "#64748b", textTransform: "uppercase" }}>Announcement</th>
                              <th style={{ textAlign: "left", padding: "12px 16px", fontSize: "11px", fontWeight: "800", color: "#64748b", textTransform: "uppercase" }}>Date</th>
                              <th style={{ textAlign: "left", padding: "12px 16px", fontSize: "11px", fontWeight: "800", color: "#64748b", textTransform: "uppercase" }}>Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              [...Array(3)].map((_, index) => (
                                <tr key={index} style={{ borderBottom: "1px solid #f1f5f9" }}>
                                  <td style={{ padding: "14px 16px" }}><span className="skeleton" style={{ width: "80%", height: "14px", borderRadius: "4px" }}></span></td>
                                  <td style={{ padding: "14px 16px" }}><span className="skeleton" style={{ width: "60px", height: "14px", borderRadius: "4px" }}></span></td>
                                  <td style={{ padding: "14px 16px" }}><span className="skeleton" style={{ width: "60px", height: "14px", borderRadius: "4px" }}></span></td>
                                </tr>
                              ))
                            ) : announcement && announcement.length > 0 ? (
                              announcement.map((item, index) => (
                                <tr key={index} style={{ borderBottom: "1px solid #f1f5f9" }}>
                                  <td style={{ padding: "14px 16px", fontSize: "13px", fontWeight: "600", color: "#334155" }}>{item.name}</td>
                                  <td style={{ padding: "14px 16px", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>{item.lastUpdate}</td>
                                  <td style={{ padding: "14px 16px", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>{item.time}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" style={{ padding: "20px", textAlign: "center", color: "#94a3b8", fontSize: "13px" }}>No announcements available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-20" style={{ flexBasis: "calc(24% - 6px)", display: "flex", flexDirection: "column", gap: "24px" }}>
              {/* Daily Checklist Card */}
              <div
                style={{
                  background: "white",
                  borderRadius: "24px",
                  padding: "24px",
                  border: "1px solid rgba(226, 232, 240, 0.8)",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
                  <FaCheckSquare style={{ color: "#10b981" }} />
                  <p style={{ margin: 0, fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Daily Tasks</p>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  {instructorChecklist.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => handleToggleInstructorChecklist(item.id)}
                      style={{
                        display: "flex",
                        alignItems: "start",
                        gap: "10px",
                        cursor: "pointer",
                        padding: "8px 10px",
                        borderRadius: "10px",
                        background: item.checked ? "#f8fafc" : "transparent",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = "#f1f5f9"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = item.checked ? "#f8fafc" : "transparent"; }}
                    >
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          borderRadius: "4px",
                          border: "2px solid #cbd5e1",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "2px",
                          borderColor: item.checked ? "#10b981" : "#cbd5e1",
                          background: item.checked ? "#10b981" : "transparent",
                          transition: "all 0.2s ease",
                          flexShrink: 0,
                        }}
                      >
                        {item.checked && <FaCheck style={{ color: "white", fontSize: "10px" }} />}
                      </div>
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: item.checked ? "#94a3b8" : "#475569",
                          textDecoration: item.checked ? "line-through" : "none",
                        }}
                      >
                        {item.text}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Sidebar Calendar & Student List */}
              <div
                style={{
                  background: "white",
                  borderRadius: "24px",
                  padding: "24px",
                  border: "1px solid rgba(226, 232, 240, 0.8)",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                }}
              >
                <p style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>
                  My Students
                </p>
                <TeacherAdminData instructor={true} />
              </div>

              <div
                style={{
                  background: "white",
                  borderRadius: "24px",
                  padding: "24px",
                  border: "1px solid rgba(226, 232, 240, 0.8)",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
                }}
              >
                <p style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>
                  Event Calendar
                </p>
                <DashboardCalendar />
              </div>
            </div>
          </div>

          {/* Attendance and Verification widgets */}
          <div style={{ display: "flex", flexDirection: "column", gap: "24px", marginTop: "24px" }}>
            <div
              style={{
                background: "white",
                borderRadius: "24px",
                padding: "24px",
                border: "1px solid rgba(226, 232, 240, 0.8)",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
              }}
            >
              <InstructorAttendance />
            </div>

            <div
              style={{
                background: "white",
                borderRadius: "24px",
                padding: "24px",
                border: "1px solid rgba(226, 232, 240, 0.8)",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
              }}
            >
              <VerifyAttendance />
            </div>
          </div>
        </div>
      </AuthorizedWrapper>

      <AuthorizedWrapper authorizedRoles={["Institute"]}>
        <>
          <div className="welcome-screen">
            <div className="wel-left">
              <UserAvatar styleName="dashboard" />
            </div>
            <div className="wel-right">
              <div className="title">Hi,{props.user.firstName}</div>
              <div className="description admin-card-name">
                ENTERPRISE DASHBOARD
              </div>
            </div>
            <div className="wel-extreme-right">
              <div>
                <div className="card-title admin-card">WEBINARS</div>
                <div className="card-count admin-card">
                  {fetchrecord && fetchrecord.webinars}
                </div>
              </div>
              <div>
                <div className="card-title admin-card">COURSES</div>
                <div className="card-count">
                  <span className="percent admin-card">
                    {fetchrecord && fetchrecord.courses}
                  </span>
                </div>
              </div>
              <div>
                <div className="card-title admin-card">INSTRUCTORS</div>
                <div className="card-count admin-card">
                  {fetchrecord && fetchrecord.instructors}
                </div>
              </div>
              <div>
                <div className="card-title admin-card">STUDENTS</div>
                <div className="card-count admin-card">
                  {fetchrecord && fetchrecord.students}
                </div>
              </div>
              <div>
                <div className="card-title admin-card">MODERATION</div>
                <div className="card-count admin-card">
                  {fetchrecord && fetchrecord.moderation}
                </div>
              </div>
            </div>
          </div>

          <CourseList role={props.user.role} />
        </>
      </AuthorizedWrapper>

      <AuthorizedWrapper authorizedRoles={["Student"]}>
        <StudentDashboard />
      </AuthorizedWrapper>

      {/* Announcement Creator Modal */}
      {showAnnouncementModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(15, 23, 42, 0.6)",
            backdropFilter: "blur(4px)",
            fontFamily: "'Outfit', sans-serif",
          }}
          onClick={() => setShowAnnouncementModal(false)}
        >
          <div
            style={{
              background: "white",
              borderRadius: "24px",
              width: "100%",
              maxWidth: "480px",
              padding: "32px",
              boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              border: "1px solid #f1f5f9",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "800", color: "#0f172a" }}>
                Post System Announcement
              </h3>
              <button
                onClick={() => setShowAnnouncementModal(false)}
                style={{
                  border: "none",
                  background: "#f1f5f9",
                  color: "#64748b",
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "700",
                }}
              >
                <FaTimes />
              </button>
            </div>

            {announcementError && (
              <div style={{ padding: "12px", background: "#fef2f2", color: "#991b1b", borderRadius: "12px", fontSize: "13px", fontWeight: "700", marginBottom: "16px", border: "1px solid #fee2e2" }}>
                {announcementError}
              </div>
            )}
            {announcementSuccess && (
              <div style={{ padding: "12px", background: "#ecfdf5", color: "#065f46", borderRadius: "12px", fontSize: "13px", fontWeight: "700", marginBottom: "16px", border: "1px solid #d1fae5" }}>
                {announcementSuccess}
              </div>
            )}

            <form onSubmit={handlePostAnnouncement} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: "800", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "6px" }}>
                  Announcement Title
                </label>
                <input
                  type="text"
                  placeholder="e.g. Server Maintenance or New Course Upload"
                  value={newAnnouncement.title}
                  onChange={(e) => setNewAnnouncement(prev => ({ ...prev, title: e.target.value }))}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: "12px",
                    border: "1px solid #cbd5e1",
                    fontSize: "13px",
                    fontWeight: "600",
                    outline: "none",
                  }}
                  required
                />
              </div>

              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: "800", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "6px" }}>
                  Content Description
                </label>
                <textarea
                  placeholder="Provide details for the students and teachers..."
                  value={newAnnouncement.description}
                  onChange={(e) => setNewAnnouncement(prev => ({ ...prev, description: e.target.value }))}
                  rows="4"
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: "12px",
                    border: "1px solid #cbd5e1",
                    fontSize: "13px",
                    fontWeight: "600",
                    outline: "none",
                    resize: "none",
                  }}
                  required
                />
              </div>

              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: "800", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "6px" }}>
                  Target Audience
                </label>
                <select
                  value={newAnnouncement.targetGroup || "all"}
                  onChange={(e) => setNewAnnouncement(prev => ({ ...prev, targetGroup: e.target.value }))}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: "12px",
                    border: "1px solid #cbd5e1",
                    fontSize: "13px",
                    fontWeight: "600",
                    outline: "none",
                    background: "white",
                  }}
                  required
                >
                  <option value="all">All Users</option>
                  <option value="student">Only Students</option>
                  <option value="instructor">Only Instructors</option>
                  <option value="admin">Only Admins</option>
                </select>
              </div>

              <button
                type="submit"
                disabled={postingAnnouncement}
                style={{
                  background: "#0f172a",
                  color: "white",
                  border: "none",
                  padding: "12px",
                  borderRadius: "12px",
                  fontWeight: "700",
                  fontSize: "13px",
                  cursor: postingAnnouncement ? "not-allowed" : "pointer",
                  opacity: postingAnnouncement ? 0.7 : 1,
                  transition: "background 0.2s",
                }}
              >
                {postingAnnouncement ? "Publishing..." : "Publish Announcement"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  ) : (
    <Loading />
  );
}
function mapStateToProps(state) {
  const { loggedIn, user } = state.users;
  return {
    loggedIn,
    user,
  };
}
const connectedDashboard = connect(mapStateToProps)(Dashboard);
export default connectedDashboard;
